// Builds the phone number sent to the server from the country selector and
// whatever the customer typed, so "07700 900123", "7700900123" and a pasted
// "+44 7700 900123" all become the same "+447700900123".

const COUNTRY_DIGITS = { "+44": "44", "+234": "234" };

// Digits of the national number with any country code or leading zeros
// removed. Returns "" if nothing usable was typed.
export const nationalDigits = (country, typed) => {
  let digits = String(typed ?? "").replace(/\D/g, "");
  const cc = COUNTRY_DIGITS[country] || "";

  // Pasted with the country code already on the front (e.g. +44 7700 900123).
  if (cc && digits.startsWith(cc) && digits.length >= cc.length + 9) {
    digits = digits.slice(cc.length);
  }

  return digits.replace(/^0+/, "");
};

export const buildPhone = (country, typed) => {
  const national = nationalDigits(country, typed);
  return national ? `${country}${national}` : "";
};

// A usable mobile number has 9-11 digits once the country code and leading
// zero are removed.
export const isValidPhone = (country, typed) => {
  const len = nationalDigits(country, typed).length;
  return len >= 9 && len <= 11;
};
